<template>
  <div>
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8"
      :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Search</label>
          <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Status</label>
          <v-select :clearable="true" placeholder="" v-model="filters['status']"
            :options="['Pending', 'Approved', 'Rejected', 'Suspended']" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>

      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
            v-on:click="filters = {}">CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card>
          <template slot="actions">

          </template>
          <div slot="no-body" class="mt-4">
            <vs-table max-items="10" :data="rm_list" @sort="handleSort" stripe
              class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th width="20%" sort-key="code">PRODUCT CODE/NAME</vs-th>
                <vs-th width="20%" sort-key="supplier_product_code">SUPPLIER PRODUCT CODE/NAME</vs-th>
                <vs-th width="20%" sort-key="name">MANUFACTURING SITES</vs-th>
                <vs-th width="15%">APPROVAL STATUS</vs-th>
                <vs-th width="15%">PRODUCTION STAGE</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickViewManufacturing(data[indextr].id)" :key="indextr"
                  v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].code">
                    {{ data[indextr].code || '-' }}
                    <br>
                    {{ data[indextr].company_product_name ? data[indextr].company_product_name : '-' }}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier_product_code">
                    {{ data[indextr].supplier_product_code }}
                    <br>
                    {{ data[indextr].supplier_product_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].manufacturing_site">
                    <span v-for="(site, index_of_sites) in data[indextr].manufacturing_site">
                      <span class="text-primary">{{ site.site_name }}</span> ,
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].is_approved">
                    <vs-chip transparent :color="statusColorFactory(data[indextr].status ? data[indextr].status.id : '')">
                      {{ data[indextr].status ? data[indextr].status.name : '' }}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].raw_material_stage">
                    <vs-chip transparent
                      :color="data[indextr].raw_material_stage === 'production' ? 'primary' : 'warning'">
                      {{ data[indextr].raw_material_stage }}
                    </vs-chip>
                  </vs-td>


                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View" position="left">
                        <vs-button class="ml-3" @click="onClickViewManufacturing(data[indextr].id)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5"></vs-pagination>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const SupplierRepository = RepositoryFactory.get('supplier')

export default {
  name: 'RawMaterialList',
  data() {
    return {
      rm_list: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
    }
  },
  props: {
    tenant_id: {
      required: true,
      default: ''
    },
    supplier_id: {
      required: true,
      default: ''
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [Filter],
  async mounted() {
    // this.$refs.filterCard.isContentCollapsed = true
    // this.$refs.filterCard.maxHeight = '1.5rem'
  },
  methods: {
    async refreshData() {
      this.fetchRmList()
    },

    async fetchRmList() {
      this.$vs.loading()
      try {
        const { data } = await SupplierRepository.getListOfSupplierRawMaterial(this.tenant_id, this.supplier_id, this.page, this.filterQuery, 20, this.sort)
        this.rm_list = data.data
        this.meta = data.meta
      } catch (error) {

      }
      this.$vs.loading.close()
    },

    openConfirm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Remove Confirm',
        text: 'Are you sure you want to permanently remove this organization?',
        accept: this.acceptAlert
      })
    },

    acceptAlert() {
      this.$vs.notify({
        color: 'danger',
        title: 'Deleted Organization',
        position: 'top-right',
        text: 'The selected organization was successfully deleted'
      })
    },
    onClickViewManufacturing(id) {
      this.$router.push({ path: `/pages/manage-app/suppliers/${this.supplier_id}/raw-material/${id}` })
    },
    filterQueryUpdate() {
      this.fetchRmList()
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchRmList()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchRmList()
      }

    },
    statusColorFactory(id) {
      switch (id) {
        case 1:
          return 'warning'
        case 2:
          return 'danger'
        case 3:
          return 'success'
        default:
          return 'danger'
      }
    }

  },
  watch: {
    page() {
      this.fetchRmList()
    }
  }
}
</script>


<style scoped></style>
